import React from "react";
import image_2 from "../../images/agriculture/Picture16.webp";
import image_3 from "../../images/agriculture/Picture17.webp";
import image_4 from "../../images/agriculture/Picture18.webp";
import image_5 from "../../images/agriculture/Picture19.webp";
import image_1 from "../../images/agriculture/Picture2.webp";
import image_6 from "../../images/agriculture/Picture21.webp";
import image_7 from "../../images/agriculture/Picture22.webp";
import image_8 from "../../images/agriculture/Picture23.webp";

const imgData = [
  {
    id: 1,
    image: image_2,
  },
  {
    id: 2,
    image: image_3,
  },
  {
    id: 3,
    image: image_4,
  },
  {
    id: 4,
    image: image_5,
  },
];

const FairTradeQuality = () => {
  return (
    <section id="fair-trade-&-quality">
      <div className="fair-trade-quality-container">
        <div className="ms-13 me-13 pt-7 pb-7 text-center">
          <img src={image_1} className="img-fluid" alt="" />
          <h1 className="fs-56 lh-64 text-uppercase gilroy-bold text-white pt-5">
            Fair Trade & Quality
          </h1>
        </div>
      </div>
      <div className="bg-white text-center">
        {imgData.map((data) => (
          <div className="d-inline-block mx-5 py-5" key={data?.id}>
            <img
              src={data?.image}
              loading="lazy"
              className="img-fluid card-design-2"
              alt=""
            />
          </div>
        ))}
      </div>
      <div className="bg-chinese-black text-white">
        <div className="ms-47 me-47 pt-7 pb-7">
          <div className="row">
            <div className="col-lg-2 col-xl-2 text-center text-lg-start">
              <div>
                <img
                  src={image_6}
                  loading="lazy"
                  className="img-fluid card-design-2"
                  alt=""
                />
              </div>
              <div className="my-5 py-5">
                <img
                  src={image_7}
                  loading="lazy"
                  className="img-fluid card-design-2"
                  alt=""
                />
              </div>
              <div>
                <img
                  src={image_8}
                  loading="lazy"
                  className="img-fluid card-design-2"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg-10 col-xl-10">
              <p className="fs-20 lh-30 text-align-justify">
                SEGAM Agriculture & Trade was established fulfil the ambitious
                goal of its founders to supply high-quality, natural and healthy
                products at affordable prices to its global consumers .
              </p>
              <p className="fs-20 lh-30 text-align-justify">
                We adopt a strict adherence to superior quality standards and by
                diligently meeting the needs of an increasingly sophisticated
                and health-conscious market. Our goal is to become a leading
                Egyptian exporter to new and emerging markets. Through our
                 economies of scale, as well as sound marketing and distribution
                policies we are able to provide competitive and high quality
                produce to our global consumers whilst ensuring a fair trade
                policy towards our local farmers. 
              </p>
              <p className="fs-20 lh-30 text-align-justify">
                In order to offer superior quality Fresh Fruits & Vegetables in
                the market, we been associated with some of the most trusted
                vendors of the industry. These products are cultivated or grown
                at large farms, orchards or fields. The entire range is grown
                without using pesticides or other harmful products and by
                employing the most modern technology, methodology & equipment.
                We make sure to offer products that comply with the
                international food grade standards. Our product range is
                thoroughly checked on certain well-defined parameters and packed
                using genuine quality packaging material. Owing to the flawless
                nature, our product range is highly demanded all across the
                nation.
              </p>
              <p className="fs-20 lh-30 text-align-justify">
                We have a spacious warehouse to store the entire range procured
                by us. This is managed by a team of warehousing personnel who
                maintain favourable conditions at our warehouse. They put in
                their best efforts to maintain precise humidity, temperature and
                other factors at our warehouse that ensure safe storage of the
                products. We also have a team of experts who procure the fruits
                and vegetables as per the market demand. They also pack the
                entire range using genuine quality material, which enhances its
                shelf life and safety. Our quality control experts also check
                the entire range on certain well-defined parameters to gauge its
                flawless nature. Moreover, the logistics personnel associated
                with us make sure to deliver the ordered products at the
                clients’ end within the committed time frame.
              </p>
              <p className="fs-16 lh-30 text-align-justify pt-5">
                *** Quality Marks subject to certification agreements with our
                farmers
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FairTradeQuality;
